function convertILetrusToLevel(iLetrus: number) {
  if (iLetrus < 0.3) {
    return 1;
  }
  if (iLetrus >= 0.3 && iLetrus < 0.48) {
    return 2;
  }
  if (iLetrus >= 0.48 && iLetrus < 0.65) {
    return 3;
  }
  if (iLetrus >= 0.65 && iLetrus < 0.8) {
    return 4;
  }
  if (iLetrus >= 0.8) {
    return 5;
  }
}

export default convertILetrusToLevel;
